import { COLORS } from '@cuemath/comps';

type ObjectType = Record<string, string>;

export const LOGIN_COLORS: ObjectType = {
  PINK: 'PINK',
  BLUE: 'BLUE',
  GREEN: 'GREEN',
  YELLOW: 'YELLOW',
} as const;

export const STAR_CODES: ObjectType = {
  GREEN: COLORS.GRASS_LIGHT,
  PINK: COLORS.FLOWER_LIGHT,
  BLUE: COLORS.SKY_LIGHT,
  YELLOW: COLORS.SUN_LIGHT,
} as const;

export const BG_CODES: ObjectType = {
  PINK: COLORS.FLOWER,
  BLUE: COLORS.SKY,
  GREEN: COLORS.GRASS,
  YELLOW: COLORS.SUN,
} as const;
